<template>

    <div class="flex justify-center mx-auto w-full bg-racing-stars-dirty-yellow rounded-md border transition duration-100 ease-in-out border-racing-stars-yellow hover:bg-[#544f2b] active:bg-[#635d30] animate-flow">
        <div v-for="reward in rewards" class="flex flex-col justify-center items-center w-full p-4">
            {{ reward.named }}
            {{ reward.amount }}
           {{ reward.uuid }} //maybe dont display this?
             {{ reward.created_at}}

<!--add QR code note: needs white background 10px~ to work-->
            QR code link: https://racingstars.co.uk/rewards/qrclaim/{{ reward.uuid }}
        </div>
    </div>

</template>

<script>

import { ChevronUpIcon } from '@heroicons/vue/outline'
import { GiftIcon } from '@heroicons/vue/outline'
import { ref, onMounted } from 'vue'

export default {

    components: {
        ChevronUpIcon,
        GiftIcon
    },

    setup(props) {
        const rewards = ref([])

        const getRewards = () => {
            axios.post(route('api.reward.getunclaimed'), {
                source: 'meeting'
            })
                .then(response => {
                    rewards.value = response.data
                });
            console.log(rewards)
            return rewards
        }

        onMounted(() => {
            getRewards()
        })

        return {
            rewards,
        }
    },


}

</script>
